module.exports = __webpack_public_path__ + "f3046dfdd5078b518e5107b2e084ea95.png";